export const inputImgList = [{
  src: require('../../assets/img/img_1.jpg'),
  text: '拼音9键'
}, {
  src: require('../../assets/img/img_2.jpg'),
  text: '拼音26键'
}, {
  src: require('../../assets/img/img_3.jpg'),
  text: '五笔输入'
}, {
  src: require('../../assets/img/img_4.jpg'),
  text: '多语言-阿拉伯语言'
}, {
  src: require('../../assets/img/img_5.jpg'),
  text: '多语言-日语'
}, {
  src: require('../../assets/img/img_6.jpg'),
  text: '多语言-韩语'
}, {
  src: require('../../assets/img/img_7.jpg'),
  text: '手写英文'
}, {
  src: require('../../assets/img/img_8.jpg'),
  text: '手写输入'
}, {
  src: require('../../assets/img/img_9.jpg'),
  text: '语音输入'
}]

export const apImgList = [{
  src: require('../../assets/img/img_10.jpg'),
  text: '工业设备'
}, {
  src: require('../../assets/img/img_11.jpg'),
  text: '医疗器械'
}, {
  src: require('../../assets/img/img_12.jpg'),
  text: 'ATM'
}, {
  src: require('../../assets/img/img_13.jpg'),
  text: '车载'
}]

export const hardwareImgList = [{
  src: require('../../assets/img/img_14.jpg'),
  text: '物理键盘'
}, {
  src: require('../../assets/img/img_15.jpg'),
  text: '触屏输入'
}]

export const opTextList = ['麒麟v4、v7、v10', '优麒麟', '统信UOS v20', '深度', '鲲鹏']

export const cpuImgList = [{
  src: require('../../assets/img/img_16.jpg'),
}, {
  src: require('../../assets/img/img_17.jpg'),
}, {
  src: require('../../assets/img/img_18.jpg'),
}, {
  src: require('../../assets/img/img_19.jpg'),
}, {
  src: require('../../assets/img/img_20.jpg'),
}]

export const cusImgList = [{
  src: require('../../assets/img/img_21.jpg'),
  text: '多种部署方式',
}, {
  src: require('../../assets/img/img_22.jpg'),
  text: '全链路跟踪管理',
}, {
  src: require('../../assets/img/img_23.jpg'),
  text: '定制化方案',
}]
export const comItrImgList = [{
  src: require('../../assets/img/img_24.jpg'),
}, {
  src: require('../../assets/img/img_25.jpg'),
}]
export const codeImgList = [{
  src: require('../../assets/img/code-1.png'),
  text: '江疆-副总经理',
}, {
  src: require('../../assets/img/code-2.png'),
  text: '付然-商务经理',
}]